module.exports = __webpack_public_path__ + "images/treehouse.jpg";